import { Post } from '../services/postService';

export type SchoolTrackKey = 'short' | 'long';

export interface SchoolTrack {
  key: SchoolTrackKey;
  label: string;
  description: string;
  slugHints: string[];
  nameHints: string[];
  coursePath: string;
  accentGradient: string;
}

export const SCHOOL_TRACKS: SchoolTrack[] = [
  {
    key: 'short',
    label: 'Trường phái video ngắn',
    description: 'Chinh phục short-form chỉ trong vài phút mỗi ngày.',
    slugHints: ['short-video-school', 'truong-phai-video-ngan', 'video-ngan'],
    nameHints: ['video ngắn', 'short form', 'short video'],
    coursePath: '/khoa-hoc/video-ngan',
    accentGradient: 'from-pink-500/90 to-rose-500/90',
  },
  {
    key: 'long',
    label: 'Trường phái video dài',
    description: 'Tạo series dài hơi và xây dựng cộng đồng trung thành.',
    slugHints: ['long-video-school', 'truong-phai-video-dai', 'video-dai'],
    nameHints: ['video dài', 'long form', 'long video'],
    coursePath: '/khoa-hoc/video-dai',
    accentGradient: 'from-indigo-500/90 to-blue-500/90',
  },
];

export const normalizeText = (value?: string | null) =>
  value ? value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim() : '';

export const summarizeContent = (input?: string | null, limit = 200) => {
  if (!input) return '';
  const stripped = input.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  if (!stripped) return '';
  return stripped.length > limit ? `${stripped.slice(0, limit).trim()}…` : stripped;
};

export const isSchoolTrackMatch = (value?: string | null) => {
  const normalized = normalizeText(value);
  if (!normalized) return false;
  return SCHOOL_TRACKS.some((track) => {
    const slugMatch = track.slugHints.some((hint) => normalizeText(hint) === normalized);
    const nameMatch = track.nameHints.some((hint) => normalized.includes(normalizeText(hint)));
    return slugMatch || nameMatch;
  });
};

export const buildSlidesByTrack = (posts: Post[]): Record<SchoolTrackKey, Post[]> => {
  const base = SCHOOL_TRACKS.reduce(
    (acc, track) => {
      acc[track.key] = [];
      return acc;
    },
    {} as Record<SchoolTrackKey, Post[]>
  );

  posts.forEach((post) => {
    if (!post?.author || post.author.role !== 'admin') return;
    if (post.status && post.status !== 'approved') return;

    const categorySlug = normalizeText(post.category?.slug);
    const categoryName = normalizeText(post.category?.name);
    const normalizedTags = (post.tags || []).map((tag) => normalizeText(tag));
    const tagsAsString = normalizedTags.join(' ');

    SCHOOL_TRACKS.forEach((track) => {
      const slugMatch = categorySlug && track.slugHints.some((hint) => normalizeText(hint) === categorySlug);
      const nameMatch = categoryName && track.nameHints.some((hint) => categoryName.includes(normalizeText(hint)));
      const tagMatch =
        normalizedTags.length > 0 &&
        (normalizedTags.some((tag) => track.slugHints.some((hint) => normalizeText(hint) === tag)) ||
          (tagsAsString && track.nameHints.some((hint) => tagsAsString.includes(normalizeText(hint)))));

      if (slugMatch || nameMatch || tagMatch) {
        base[track.key].push(post);
      }
    });
  });

  return base;
};




